import { Action } from '@reduxjs/toolkit';
import { combineEpics, StateObservable } from 'redux-observable';
import { Observable } from 'rxjs';
import {
  map, ignoreElements, tap, filter,
} from 'rxjs/operators';

import { ls } from '@ezugi/utils';

import { MEDIA } from '../../../constants';
import { updateVideoVolume } from '../../../util/mediaUtils';
import { mediaActions, settingsActions } from '../../actions';
import { isVideoStreamSoundMutedSelector, volumeSelector } from '../../selectors';
import { RootState } from '../../types';

const { volume, sound, music, videoStreamSound } = mediaActions;
const { settings } = settingsActions;

const volumeEpic = (action$: Observable<Action>) => action$.pipe(
  filter(volume.set.match),
  map(({ payload }) => {
    const [ err ] = ls.put(MEDIA.VOLUME, payload);
    updateVideoVolume(payload);
    return err ? volume.failure() : volume.success();
  })
);

const gameSoundsEpic = (action$: Observable<any>): Observable<any> => action$.pipe(
  filter((action) => sound.toggle.type === action.type
   || music.toggle.type === action.type
   || videoStreamSound.toggle.type === action.type),
  map(settings.update)
);

const videoStreamToggleAndSetEpic = (action$: Observable<Action>, state$: StateObservable<RootState>) => action$.pipe(
  filter((action) => videoStreamSound.toggle.match(action) || videoStreamSound.set.match(action)),
  tap(() => {
    const volumeState = volumeSelector(state$.value);

    let computedMutedValue = volumeState.muted;
    if (!volumeState.muted) {
      computedMutedValue = isVideoStreamSoundMutedSelector(state$.value);
    }

    updateVideoVolume({ ...volumeState, muted: computedMutedValue });
  }),
  ignoreElements(),
);

export default combineEpics(volumeEpic, gameSoundsEpic, videoStreamToggleAndSetEpic);
